import { Link } from 'react-router-dom'
import { AppLayout } from '../components/AppLayout'
import { SourcingPanel } from '../components/sourcing/SourcingPanel'
import { WantListPanel } from '../components/sourcing/WantListPanel'

/**
 * /sourcing — the buy-side limit-order desk. A KYC-verified buyer states a spec
 * + a ceiling price and DiaEx sources the cheapest match across suppliers. The
 * body is the shared <SourcingPanel/> (identical on mobile), which shows the
 * pitch while SOURCING_ORDERS_LIVE is inert and the live desk once armed.
 */
export function Sourcing() {
  return (
    <AppLayout>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-10">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gold">Buyer</p>
            <h1 className="mt-1 font-serif text-3xl font-bold tracking-tight text-ink">Source a diamond</h1>
            <p className="mt-1 text-sm text-soft">Name your spec and ceiling price — we find the cheapest match.</p>
          </div>
          <Link
            to="/search"
            className="inline-flex h-10 shrink-0 items-center rounded-full bg-navy px-5 text-sm font-semibold text-white no-underline hover:bg-navy-hover active:scale-[0.98] transition-all"
          >
            Browse diamonds
          </Link>
        </div>
        <div className="mt-8">
          <SourcingPanel />
        </div>
        {/* Agentic-sourcing want-list (docs/ASKA-PLUS-AGENTIC-SOURCING.md) —
            self-gates on rfqLive: pitch/"coming soon" until SOURCING_RFQ_LIVE. */}
        <div className="mt-8">
          <WantListPanel />
        </div>
      </div>
    </AppLayout>
  )
}
